import * as React from 'react';
import { ModalContent } from './components/ModalContent';
import { ModalHeader } from './components/ModalHeader';
import { OffersTable } from '../OffersTable';
import { Skeleton } from './components/Skeleton';
import { ErrorScreen } from './components/ErrorScreen';
import { useOffers } from '../../../../hooks';
import { useCompareRequests } from '../../../../hooks/useCompareRequests';
import { CompareNotificationContainer } from '../CompareNotification';
import { OffersContext } from '../../../../shared/context';
import { useFavorite } from '../../../../hooks/useFavorite';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var OffersModalContainer = function OffersModalContainer(_ref) {
  var contactsButton = _ref.contactsButton,
    houseId = _ref.houseId,
    layoutKey = _ref.layoutKey,
    newbuildingId = _ref.newbuildingId;
  var _useOffers = useOffers({
      houseId: houseId,
      layoutKey: layoutKey,
      newbuildingId: newbuildingId
    }),
    layout = _useOffers.layout,
    contact = _useOffers.contact,
    onRetry = _useOffers.onRetry,
    error = _useOffers.error,
    loading = _useOffers.loading,
    setComparisonStatus = _useOffers.setComparisonStatus,
    setFavoriteStatus = _useOffers.setFavoriteStatus;
  var _useCompareRequests = useCompareRequests({
      setComparisonStatus: setComparisonStatus
    }),
    addOfferToComparison = _useCompareRequests.addOfferToComparison,
    removeOfferFromComparison = _useCompareRequests.removeOfferFromComparison,
    clearNotification = _useCompareRequests.clearNotification,
    notification = _useCompareRequests.notification;
  var _useFavorite = useFavorite({
      setFavoriteStatus: setFavoriteStatus
    }),
    addOfferToFavorites = _useFavorite.addOfferToFavorites,
    removeOfferFromFavorites = _useFavorite.removeOfferFromFavorites;
  var context = React.useMemo(function () {
    return {
      layout: layout,
      addOfferToComparison: addOfferToComparison,
      removeOfferFromComparison: removeOfferFromComparison,
      addOfferToFavorites: addOfferToFavorites,
      removeOfferFromFavorites: removeOfferFromFavorites
    };
  }, [layout, addOfferToComparison, removeOfferFromComparison, addOfferToFavorites, removeOfferFromFavorites]);
  if (error) {
    return /*#__PURE__*/_jsx(ErrorScreen, {
      onRetry: onRetry
    });
  }
  if (loading || !layout) {
    return /*#__PURE__*/_jsx(Skeleton, {});
  }
  return /*#__PURE__*/_jsx(OffersContext.Provider, {
    value: context,
    children: /*#__PURE__*/_jsxs(ModalContent, {
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        contactsButton: contactsButton,
        contact: contact
      }), /*#__PURE__*/_jsx(OffersTable, {}), /*#__PURE__*/_jsx(CompareNotificationContainer, {
        notification: notification,
        clearNotification: clearNotification
      })]
    })
  });
};